import React, { FC, useEffect, useState } from 'react';
import { StoryItem, StoryTeaserService } from '../../services/story-teaser';
import { TeaserService } from '../../services/teaser';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { RocheUIStoryStagingHero, RocheUIStoryType, RocheUIHeroVariant, RocheUIImageRatio } from '@repo/roche-ui';
import { useStoryTypeTranslation } from '../../hooks/use-story-type-translation';
import { getImageOrVideo } from '../../helpers/slotted-to-image';
import { SlottedImageDataType } from '../../helpers/slotted-to-image/types';

type RocheStoryStagingHeroProps = BlokToComponentProps<{
  preRenderContent?: StoryItem;
  slotted_story_image: SlottedImageDataType[];
  layout?: string;
  story_headline?: string;
  story_description?: string;
  show_tags?: boolean;
}>;

export const RocheStoryStagingHero: FC<RocheStoryStagingHeroProps> = ({ blok, slot, storyId }) => {
  if (!blok) {
    return null;
  }

  const [teaser, setTeaser] = useState<StoryItem>(blok.preRenderContent || ({} as StoryItem));
  useEffect(() => {
    if (!storyId) {
      return;
    }

    if (!teaser || Object.keys(teaser).length === 0) {
      StoryTeaserService.getStoryTeaser(storyId as number).then((result) => {
        if (result === undefined) {
          // edge case: could not load teaser of story, try loading teaser of page
          // functionality should be changed: https://roche-ds.atlassian.net/browse/EXTCWP-844
          return TeaserService.getTeaser(storyId as number).then(async (result) => {
            setTeaser(result);
          });
        } else {
          setTeaser(result);
        }
      });
    }
  }, []);

  const storyType = teaser?.content?.teaser_type as RocheUIStoryType;
  const storyTypeTranslation = useStoryTypeTranslation(storyType);

  return (
    <RocheUIStoryStagingHero
      variant={blok?.layout as RocheUIHeroVariant}
      storyHeadline={blok?.story_headline}
      storyType={storyType}
      storyTypeTranslation={storyTypeTranslation}
      storyDescription={blok?.story_description}
      showTags={blok?.show_tags}
      Image={getImageOrVideo(blok?.slotted_story_image, RocheUIImageRatio.WIDE)}
      storyTags={teaser?.content?.tag}
      slot={slot}
    />
  );
};
